import { useTranslation } from "react-i18next";
import singleMode from "./selectBaseSingle";

const rawItems = [
	{ key: 0, value: "january", code: 1 },
	{ key: 1, value: "february", code: 2 },
	{ key: 2, value: "march", code: 3 },
	{ key: 3, value: "april", code: 4 },
	{ key: 4, value: "may", code: 5 },
	{ key: 5, value: "june", code: 6 },
	{ key: 6, value: "july", code: 7 },
	{ key: 7, value: "august", code: 8 },
	{ key: 8, value: "september", code: 9 },
	{ key: 9, value: "october", code: 10 },
	{ key: 10, value: "november", code: 11 },
	{ key: 11, value: "december", code: 12 },
];

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.code : null;
	},
	valueToSelectorParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.key : null;
	},
	codeToValue: (value) => {
		const current = rawItems.find((item) => item.code === value);
		return current ? current.value : null;
	},
};

export default ({ initial }) => {
	const { t } = useTranslation(["common"]);

	const items = rawItems.map((item) => ({
		...item,
		content: t(`months.${item.value}`),
	}));

	return {
		items,
		compute,
		...singleMode({ items, initial }),
	};
};
